import React from 'react';
import Box from './Box';

interface StackProps extends React.HTMLAttributes<HTMLDivElement> {
  gap?: number | string;
  align?: 'start' | 'center' | 'end' | 'stretch' | 'baseline';
  justify?: 'start' | 'center' | 'end' | 'between' | 'around' | 'evenly';
  wrap?: 'wrap' | 'nowrap' | 'wrap-reverse';
  className?: string;
  children?: React.ReactNode;
}

const VStack = React.forwardRef<HTMLDivElement, StackProps>(
  ({ gap = 4, align, justify, wrap, className, children, ...rest }, ref) => (
    <Box
      ref={ref}
      direction="col"
      gap={gap}
      align={align}
      justify={justify}
      wrap={wrap}
      className={className}
      {...rest}
    >
      {children}
    </Box>
  ),
);
VStack.displayName = 'VStack';

const HStack = React.forwardRef<HTMLDivElement, StackProps>(
  ({ gap = 2, align = 'center', justify, wrap, className, children, ...rest }, ref) => (
    <Box
      ref={ref}
      direction="row"
      gap={gap}
      align={align}
      justify={justify}
      wrap={wrap}
      className={className}
      {...rest}
    >
      {children}
    </Box>
  ),
);
HStack.displayName = 'HStack';

export { VStack, HStack };
export type { StackProps };
